import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PaymentsState } from './payment.reducers';

// tslint:disable: max-line-length
export const paymentsFeatureStateSelector = createFeatureSelector<PaymentsState>('payment');

export const selectPayments = createSelector(paymentsFeatureStateSelector, (state: PaymentsState) => state.payments);
